import { lazy } from 'react';
import { loadReducersAndSagas } from '../../services/LazyLoadComponent';

export default lazy(() => import(/* webpackChunkName: 'ReviewCycleCreate' */ '.').then(loadReducersAndSagas));
